<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import {EditableArea} from "@magnolia/vue-editor";

const props = defineProps<{
  specificationsArea: Area;
  metadata: Area;
  title?: string;
  category?: string;
}>();

const itemsGrid = ref(props.specificationsArea['@nodes'].length);
const contentWrapperCss = () => {
  if (itemsGrid.value === 1) {
    return 'inner-content-grid'
  }
  return 'col-breakout'
}

const contentFlexGridCss = () => {
  if (itemsGrid.value === 1) {
    return 'flex flex-col';
  }

  return 'flex flex-col lg:flex-row justify-between justify-end gap-8';
}

</script>

<template>
  <div class="article-margin col-breakout py-8 px-8 lg:py-10 bg-black text-white">
    <div class="inner-content-grid gap-8">
      <h2 class="text-2xl lg:text-3xl text uppercase" v-if="title">{{ title }}</h2>
      <EditableArea
          v-if="specificationsArea"
          :content="specificationsArea"
          class="specifications"
          :class="contentFlexGridCss()">
      </EditableArea>
      <div v-if="category" class="col-span-full justify-self-end self-end uppercase text-sm">{{ category }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
